import styled from 'styled-components'
import pxToRem from '../../utils/pxToRem'
import { deviceMax } from '../../theme/breakpoints'

export const StyledCard = styled.div`
  position: relative;
  flex-direction: column;
  display: flex;
  margin-bottom: ${pxToRem(20)};
  border-radius: ${pxToRem(5)};
  padding: ${pxToRem(9)} ${pxToRem(9)} ${pxToRem(9)} ${pxToRem(40)};
  width: 100%;
  max-width: ${pxToRem(385)};
  background-color: ${({ theme }) => theme.colors.unique.white};
  @media ${deviceMax.mobileL} {
    margin-left: auto;
    margin-right: auto;
  }
`
export const StyledSeparator = styled.div`
  position: absolute;
  top: ${pxToRem(19.5)};
  left: ${pxToRem(10)};
  width: ${pxToRem(20)};
  height: ${pxToRem(2)};
  background-color: ${({ theme }) => theme.colors.primary.lime};
`

export const StyledDepartment = styled.p`
  margin-bottom: ${pxToRem(6)};
  font-size: ${({ theme }) => theme.fonts.sizes.titleH3.base};
  font-weight: ${({ theme }) => theme.fonts.weight.bold};
  line-height: ${({ theme }) => theme.fonts.lineHeight.titleH3};
`

export const StyledFullName = styled.p`
  margin-bottom: ${pxToRem(6)};
  font-size: ${({ theme }) => theme.fonts.sizes.base};
  font-weight: ${({ theme }) => theme.fonts.weight.semibold};
  line-height: ${({ theme }) => theme.fonts.lineHeight.base};
`
export const StyledPhone = styled.a`
  margin-bottom: ${pxToRem(6)};
  font-size: ${({ theme }) => theme.fonts.sizes.base};
  font-weight: ${({ theme }) => theme.fonts.weight.normal};
  line-height: ${({ theme }) => theme.fonts.lineHeight.base};
`
export const StyleEmail = styled.a`
  font-size: ${({ theme }) => theme.fonts.sizes.base};
  font-weight: ${({ theme }) => theme.fonts.weight.normal};
  line-height: ${({ theme }) => theme.fonts.lineHeight.base};
`
